import { Helmet } from 'react-helmet-async';

const HomePageHelmet = () => {
  return (
    <Helmet>
      {/* Title & Meta */}
      <title>
        Velocent Global - Secure Logistics for Gold, Cash & Valuables
      </title>
      <meta
        name='description'
        content='Velocent Global provides secure logistics and transportation solutions for gold, cash, artwork, and other high-value assets. Specializing in air and road freight, we ensure trusted, discreet, and timely delivery worldwide.'
      />
      <meta
        name='keywords'
        content='Velocent Global, secure logistics, valuables transport, gold logistics, cash in transit, artwork transport, high value cargo, secure air freight, secure road transport, precious metals logistics'
      />

      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property='og:type' content='website' />
      <meta property='og:url' content='https://www.velocentglobal.com' />
      <meta
        property='og:title'
        content='Velocent Global - Secure Logistics for Gold, Cash & Valuables'
      />
      <meta
        property='og:description'
        content='Trusted experts in secure logistics. Velocent Global transports gold, cash, artwork, and high-value assets via air and road with maximum security and discretion.'
      />
      <meta
        property='og:image'
        content='https://www.velocentglobal.com/assets/images/favicon.png'
      />
      <meta property='og:site_name' content='Velocent Global' />
      <meta property='og:locale' content='en_US' />

      {/* Canonical */}
      <link rel='canonical' href='https://www.velocentglobal.com' />
    </Helmet>
  );
};

export default HomePageHelmet;
